import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import routerLoader from '../../i18n/router';
import IconSaving from '../../Icons/IconSaving';
import PapelOptionState from './papelOptionState';
import NoData from '../../components/NoData';
import { AppContextType } from '../../store/AppContext';
import EroskiDatePicker from '../../components/EroskiDatePicker';
import CustomPaginationTable from './CustomPaginationTable';
import Title from '../../components/Title';
import { CompraData } from '../../types/Types';

interface Props {
  dataApp: AppContextType;
  activo: boolean;
  visible: boolean;
  setActivo: any;
  setVisible: any;
  backErrorCompras: boolean;
  backErrorOption: boolean;
  retrieveCompraByDates: any;
  startDate: any;
  setStartDate: any;
  endDate: any;
  setEndDate: any;
  compraData: CompraData[];
  totalElements: number;
}

const ComprasTicketCaprabo: FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    dataApp,
    activo,
    visible,
    setActivo,
    setVisible,
    backErrorCompras,
    backErrorOption,
    retrieveCompraByDates,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    compraData,
    totalElements,
  } = props;

  return (
    <>
      {(() => {
        return (
          <>
            <section className="o-section--no-padding-top  section--background">
              <div className="container">
                <div className="cabecera-seccion">
                  <Title titleName={t('compras.title')} page="compras" />
                  <div className="links-cabecera">
                    <div className="icon-link-block u-margin-bottom-small">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        href={routerLoader.LoadRouterByPath(
                          'ahorros',
                          dataApp.lang,
                        )}
                        className="icon-link u-align-items-baseline"
                      >
                        <div className="icon icon-medium icon--grey ">
                          <IconSaving />
                        </div>
                        <span className="u-font-small u-text-brand u-text-decoration-underline">
                          {t('compras.mySavings')}
                        </span>
                      </a>
                    </div>
                    <div className="form-group form-group-switch">
                      <span className="control-label">
                        {activo
                          ? t('compras.disactivateTicket')
                          : t('compras.activateTicket')}
                      </span>
                      <PapelOptionState
                        activo={activo}
                        visible={visible}
                        setVisible={setVisible}
                        setActivo={setActivo}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="o-section--large comprasPage">
              <div className="container-inner__small">
                {(() => {
                  if (!backErrorCompras && !backErrorOption) {
                    return (
                      <>
                        <form
                          id="selectores-fechas"
                          className="u-display-flex u-justify-content-center u-margin-bottom-large u-font-small"
                          method=""
                        >
                          <EroskiDatePicker
                            type="range"
                            doAction={retrieveCompraByDates}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                          />
                        </form>

                        <CustomPaginationTable
                          data={compraData}
                          total={totalElements}
                          withPagination
                          isTicketDownloadable={activo}
                        />
                      </>
                    );
                  }
                  return (
                    <NoData>
                      <div className="mensaje">
                        <p>{t('compras.noRecords')}</p>
                      </div>
                    </NoData>
                  );
                })()}
              </div>
            </section>
          </>
        );
      })()}
    </>
  );
};

export default ComprasTicketCaprabo;
